/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
import 'corporate_common_ui/behaviors/corporate-auth-and-workflow-behaviour.js';
import 'speedboat_ui/elements/open-banking-payment-consents-input.js';
import 'speedboat_ui/elements/open-banking-payment-consents-preview.js';
import 'speedboat_ui/elements/open-banking-payment-consents-success.js';
const template = html`
    <style include="app-styles">
      .fixed-height{
        height: auto;
      }
    </style>
    <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}" notsupporteddevice={{notsupporteddevice}}></app-media-query>
    <iron-pages selected="{{selectedPage}}">
      <div>
          <open-banking-payment-consents-input action-type={{actionType}} open-banking-accounts-response={{openBankingAccountsResponse}} selected-page={{selectedPage}} preview-details={{previewDetails}} body={{body}} response-object={{responseObject}} channel-object={{channelObject}} from-preview={{fromPreview}} auth-success-object={{authSuccessObject}} auth-success={{authSuccess}}></open-banking-payment-consents-input>
      </div>
      <div>
        <div  id="stop-check-list" class="content-align-vertical-center margin-b-zero mdl-cell mdl-cell--12-col" style="margin-bottom: 10px !important;padding:15px 9%;">
          <iron-icon class="iron-icon-style-s cursor-pointer" icon="icons:arrow-back" on-tap="goToBackPage" style="color:teal;"></iron-icon> 
          <oe-i18n-msg class="cursor-pointer font-16"  msgid="b_Goback" style="color:teal" on-tap="goToInputPage"></oe-i18n-msg>
        </div> 
        <open-banking-payment-consents-preview selected-page={{selectedPage}} action-type={{actionType}}  open-banking-accounts-response={{openBankingAccountsResponse}} success-response={{successResponse}} success-obj={{successObj}} preview-details={{previewDetails}} body={{body}} response-object={{responseObject}} channel-object={{channelObject}} from-preview={{fromPreview}} auth-success-object={{authSuccessObject}} auth-success={{authSuccess}}></open-banking-account-consents-preview>
      </div>
      <div class="margin-30" style="padding:24px 10% 10%;">
          <div  id="stop-check-list" class="content-align-vertical-center margin-b-zero mdl-cell mdl-cell--12-col" style="margin-bottom: 10px !important;">
            <iron-icon class="iron-icon-style-s cursor-pointer" icon="icons:arrow-back" on-tap="goToBackPage" style="color:teal;"></iron-icon> 
            <oe-i18n-msg class="cursor-pointer font-16"  msgid="b_Goback" style="color:teal" on-tap="goToPreviewPage"></oe-i18n-msg>
          </div>  
          <fin-txn-auth-modes-landing preview-details={{previewDetails}} channel-object={{channelObject}} from-preview={{fromPreview}} auth-success-object={{authSuccessObject}} auth-success={{authSuccess}}></fin-txn-auth-modes-landing>
      </div>
      <div>
        <open-banking-payment-consents-success action-type={{actionType}} open-banking-accounts-response={{openBankingAccountsResponse}} success-response={{successResponse}} success-obj={{successObj}} preview-details={{previewDetails}}></open-banking-account-consents-success>
      </div>
    </iron-pages>
    `;
Polymer({
  is: 'open-banking-payment-consents-landing',
  _template: template,
  properties: {
    selectedPage: {
      type: String,
      value: 0,
      notify: true
    },
    body: {
      type: Object,
      notify: true
    },
    responseObject: {
      type: Object,
      notify: true
    },
    channelObject: {
      type: Object,
      notify: true
    },
    fromPreview: {
      type: Boolean,
      notify: true
    },
    authSuccess: {
      type: Boolean,
      notify: true
    },
    authSuccessObject: {
      type: Object,
      notify: true
    },
    successObj: {
      type: Object,
      notify: true
    },
    actionType: {
      type: String,
      notify: true
    }
  },
  attached() {
    this.fire('stop-processing-loader');
  },
  goToInputPage() {
    this.selectedPage = 0;
  },
  goToPreviewPage() {
    this.selectedPage = 1;
  }
});
